import Navbar from "../../../components/Navbar/Navbar";
import BillsWrapper from "../components/BillsWrapper/BillsWrapper";

export default function BillsPage() {
    return (
        <>
            <Navbar title="Bills & Payments" />
            <BillsWrapper />
        </>
    );
}
